// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GzAUNhjm0JbjbT {
  min-width: 32px;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 900px) {
  .GzAUNhjm0JbjbT .aZ0GgIOE9RoEHW {
    margin-right: var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 900px) {
  .GzAUNhjm0JbjbT .VwP7rzOx3TLBH9 {
    display: none;
  }
}
.GzAUNhjm0JbjbT.Z3I8fszR8KxDpS .aZ0GgIOE9RoEHW {
  margin-right: var(--ds-space-0, 0);
}
.GzAUNhjm0JbjbT.Z3I8fszR8KxDpS .VwP7rzOx3TLBH9 {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscribedButton": `GzAUNhjm0JbjbT`,
	"subscribedButtonIcon": `aZ0GgIOE9RoEHW`,
	"buttonText": `VwP7rzOx3TLBH9`,
	"hideText": `Z3I8fszR8KxDpS`
};
export default ___CSS_LOADER_EXPORT___;
